import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="screen"
export default class extends Controller {

  static values = {
    sync: Boolean,
    orientation: String
  }

  connect() {
    this.element.controller = this;

    document.body.classList.add(`orientation--${this.orientationValue}`);

    this.element.dataset.action =
      "error@window->screen#error online@window->screen#network offline@window->screen#network blur@window->screen#blur focus@window->screen#focus";
  }

  error() {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  network() {
    if (window.navigator.onLine) {
      console.log("ONLINE");
    } else {
      console.log("OFFLINE");
    }
  }

  blur() {
    document.querySelector('#debug').textContent = 'BLUR';
  }

  focus() {
    document.querySelector('#debug').textContent = 'FOCUS';
  }
}
